import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import pick from 'lodash.pick';
import { queryRiverTreeListAll } from '@/api/api';
import { deleteAction, httpAction } from '@/api/manage';
import MapLineString from '@/components/Map/MapLineString';
export default {
  name: 'RiverList',
  mixins: [JeecgListMixin],
  components: {
    MapLineString: MapLineString
  },
  data: function data() {
    return {
      seen: true,
      iExpandedKeys: [],
      loading: false,
      autoExpandParent: true,
      currFlowId: '',
      currFlowName: '',
      disable: true,
      treeData: [],
      visible: false,
      riverTree: [],
      rightClickSelectedKey: '',
      hiding: true,
      model: {},
      dropTrigger: '',
      river: {},
      searchValue: '',
      disableSubmit: false,
      checkedKeys: [],
      selectedKeys: [],
      autoIncr: 1,
      currSelected: {},
      nodeSelected: {},
      formTitle: '添加一级流域',
      form: this.$form.createForm(this),
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 16
        }
      },
      graphDatasource: {
        nodes: [],
        edges: []
      },
      validatorRules: {
        title: {
          rules: [{
            required: true,
            message: '请输入流域名称!'
          }]
        },
        alias: {
          rules: [{
            required: true,
            message: '请输入流域编码!'
          }]
        },
        status: {
          rules: [{
            required: true,
            message: '请选择流域状态!'
          }]
        }
      },
      url: {
        add: '/sys/river/add',
        deleteBatch: '/sys/river/deleteBatch',
        exportXlsUrl: '/sys/river/exportXls',
        importExcelUrl: '/sys/river/importExcel'
      },
      mapCenter: ''
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  created: function created() {
    this.mapCenter = window.localStorage.getItem('mapCenter');
  },
  methods: {
    /* 流域绘制起*/
    mapRegionOk: function mapRegionOk(value) {
      var that = this;

      if (value != null) {
        var a = '';
        value.forEach(function (element, index) {
          var b = '';
          element.forEach(function (item, i) {
            b += i == element.length - 1 ? item.join(',') : item.join(',') + '-';
          });
          a += index == value.length - 1 ? b : b + ':';
        });
        console.log(a, '抽屉2');
        this.form.setFieldsValue({
          mapRegion: value ? a : null
        });
        this.model.mapRegion = value ? a : null;
      }
    },
    mapRegionChange: function mapRegionChange() {
      this.$refs.mapLine.show(this.model.mapRegion);
    },

    /* 流域绘制止*/
    onChange: function onChange(e) {
      this.searchValue = e.target.value;
    },
    loadData: function loadData() {
      this.refresh();
    },
    loadTree: function loadTree() {
      var _this = this;

      var that = this;
      that.treeData = [];
      that.riverTree = [];
      queryRiverTreeListAll().then(function (res) {
        console.log(res);

        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.treeData.push(temp);
            that.riverTree.push(temp);
            console.log('temp:' + temp);
            console.log('treeData:' + that.treeData); // that.setThisExpandedKeys(temp)
          }

          _this.loading = false;
        }
      });
    },
    setThisExpandedKeys: function setThisExpandedKeys(node) {
      if (node.children && node.children.length > 0) {
        this.iExpandedKeys.push(node.key);

        for (var a = 0; a < node.children.length; a++) {
          this.setThisExpandedKeys(node.children[a]);
        }
      }
    },
    refresh: function refresh() {
      this.loading = true;
      this.loadTree();
    },
    // 右键操作方法
    rightHandle: function rightHandle(node) {
      this.dropTrigger = 'contextmenu';
      this.rightClickSelectedKey = node.node.eventKey;
    },
    onExpand: function onExpand(expandedKeys) {
      console.log('onExpand', expandedKeys); // if not set autoExpandParent to false, if children expanded, parent can not collapse.
      // or, you can remove all expanded children keys.

      this.iExpandedKeys = expandedKeys;
      this.autoExpandParent = false;
    },
    backFlowList: function backFlowList() {
      this.$router.back(-1);
    },
    // 右键点击下拉框改变事件
    dropStatus: function dropStatus(visible) {
      if (visible == false) {
        this.dropTrigger = '';
      }
    },
    // 右键下拉关闭下拉框
    closeDrop: function closeDrop() {
      this.dropTrigger = '';
    },
    addRootNode: function addRootNode() {
      this.$refs.nodeModal.add(this.currFlowId, '');
    },
    batchDel: function batchDel() {
      if (this.checkedKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
      } else {
        var ids = '';

        for (var a = 0; a < this.checkedKeys.length; a++) {
          ids += this.checkedKeys[a] + ',';
        }

        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '确定要删除所选中的 ' + this.checkedKeys.length + ' 条数据（包括下级流域）?',
          onOk: function onOk() {
            deleteAction(that.url.deleteBatch, {
              ids: ids
            }).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.loadTree();
                that.onClearSelected();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            });
          }
        });
      }
    },
    nodeModalOk: function nodeModalOk() {
      this.loadTree();
    },
    nodeModalClose: function nodeModalClose() {},
    hide: function hide() {
      this.visible = false;
    },
    onCheck: function onCheck(checkedKeys, info) {
      this.hiding = false;
      this.checkedKeys = checkedKeys.checked;
    },
    onSelect: function onSelect(selectedKeys, e) {
      this.hiding = false;
      var record = e.node.dataRef;
      var recordToForm = e.node.dataRef.data;
      console.log('onSelect-record', record);
      this.nodeSelected = Object.assign({}, record);
      this.currSelected = Object.assign({}, recordToForm);
      this.model = this.currSelected;
      this.selectedKeys = [record.key];
      this.model.parentId = recordToForm.parentId;
      this.setValuesToForm(recordToForm);
    },
    // 触发onSelect事件时,为部门树右侧的form表单赋值
    setValuesToForm: function setValuesToForm(record) {
      this.seen = record.parentId === '0';
      this.formTitle = '修改流域';
      this.form.setFieldsValue(pick(record, 'title', 'alias', 'category', 'mapRegion', 'mapCode', 'status', 'path', 'fullname', 'sort', 'remark'));
    },
    getCurrSelectedTitle: function getCurrSelectedTitle() {
      return !this.currSelected.title ? '' : this.currSelected.title;
    },
    onClearSelected: function onClearSelected() {
      this.hiding = true;
      this.checkedKeys = {};
      this.currSelected = {};
      this.nodeSelected = {};
      this.form.resetFields();
      this.selectedKeys = [];
    },
    handleNodeTypeChange: function handleNodeTypeChange(val) {
      this.currSelected.nodeType = val;
    },
    notifyTriggerTypeChange: function notifyTriggerTypeChange(value) {
      this.currSelected.notifyTriggerType = value;
    },
    receiptTriggerTypeChange: function receiptTriggerTypeChange(value) {
      this.currSelected.receiptTriggerType = value;
    },
    submitCurrForm: function submitCurrForm() {
      var _this2 = this;

      this.form.validateFields(function (err, values) {
        if (!err) {
          var formData = Object.assign(_this2.currSelected, values);
          console.log('Received values of form: ', formData);
          httpAction(_this2.url.add, formData, 'post').then(function (res) {
            if (res.success) {
              _this2.$notification.success({
                message: '保存成功!'
              });

              _this2.loadTree();

              _this2.onClearSelected();
            } else {
              _this2.$message.error(res.message);
            }
          });
        }
      });
    },
    emptyCurrForm: function emptyCurrForm() {
      this.form.resetFields();
    },
    nodeSettingFormSubmit: function nodeSettingFormSubmit() {
      this.form.validateFields(function (err, values) {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
    },
    openSelect: function openSelect() {
      this.$refs.sysDirectiveModal.show();
    },
    handleAdd: function handleAdd(num) {
      if (num == 1) {
        this.seen = true;
        this.model.parentId = null;
        this.formTitle = '添加一级流域';
        this.emptyCurrForm();
        this.onClearSelected();
      } else {
        var key = this.nodeSelected.key;

        if (!key) {
          this.$message.warning('请先选中一条记录!');
          return false;
        }

        this.seen = false;
        this.model.parentId = key;
        this.currSelected.id = null;
        this.formTitle = '添加子流域';
        this.emptyCurrForm();
      }
    },
    handleDelete: function handleDelete() {
      var that = this;
      deleteAction(that.url.deleteBatch, {
        ids: that.rightClickSelectedKey
      }).then(function (res) {
        if (res.success) {
          that.$notification.success({
            message: res.message
          });
          that.loadTree();
          that.onClearSelected();
        } else {
          that.$notification.warning({
            message: res.message
          });
        }
      });
    },
    selectDirectiveOk: function selectDirectiveOk(record) {
      console.log('选中指令数据', record);
      this.nodeSettingForm.setFieldsValue({
        directiveCode: record.directiveCode
      });
      this.currSelected.sysCode = record.sysCode;
    },
    getFlowGraphData: function getFlowGraphData(node) {
      this.graphDatasource.nodes.push({
        id: node.id,
        text: node.flowNodeName
      });

      if (node.children.length > 0) {
        for (var a = 0; a < node.children.length; a++) {
          var temp = node.children[a];
          this.graphDatasource.edges.push({
            source: node.id,
            target: temp.id
          });
          this.getFlowGraphData(temp);
        }
      }
    }
  }
};